import React from 'react';
import { Button } from '../ui/Button';
import { Shield, Lock, CheckCircle2 } from 'lucide-react';
import { trackInitiateCheckout } from '../../lib/metaPixel';
import { MiniBonuses } from './MiniBonuses';
import { useCurrencyContext } from '../../context/CurrencyContext';
import { DangerBanner } from './DangerBanner';
export function CTASection() {
  const {
    formatPrice,
    loading
  } = useCurrencyContext();
  return <section id="pricing" className="py-20 text-white text-center bg-[#101322]" data-id="element-29">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-30">
        <DangerBanner data-id="element-31" />
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white mt-6" data-id="element-32">
          No esperes a estar "bien" para empezar
        </h2>

        <p className="text-xl text-slate-300 mb-10 leading-relaxed" data-id="element-33">
          Lo necesitas precisamente porque no lo estás. Recupera el respeto por
          ti misma hoy, sin importar cuántas tareas queden pendientes.
        </p>

        <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10 mb-8" data-id="element-34">
          <div className="flex flex-col items-center" data-id="element-35">
            <span className="text-slate-400 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-36">
              Oferta Especial
            </span>
            <div className="flex items-baseline gap-2 mb-6" data-id="element-37">
              {loading ? <span className="text-6xl font-bold text-[#4FD1C5] animate-pulse" data-id="element-38">
                  ...
                </span> : <>
                  <span className="text-6xl font-bold text-[#4FD1C5]" data-id="element-39">
                    {formatPrice(6.49)}
                  </span>
                  <span className="text-slate-400 text-xl line-through" data-id="element-40">
                    {formatPrice(45)}
                  </span>
                </>}
            </div>

            <ul className="text-left w-full max-w-sm space-y-2 mb-6" data-id="element-41">
              {['Acceso inmediato y de por vida', 'Ejercicios prácticos de 5 minutos', 'Framework de Valor Intrínseco', 'Formato PDF para todos los dispositivos'].map(item => <li key={item} className="flex items-center gap-3 text-slate-300 text-sm" data-id="element-42">
                  <CheckCircle2 className="w-4 h-4 text-[#4FD1C5] flex-shrink-0" data-id="element-43" />
                  <span data-id="element-44">{item}</span>
                </li>)}
            </ul>

            <MiniBonuses data-id="element-45" />

            <Button size="lg" fullWidth className="max-w-md mb-6 text-lg" withIcon onClick={() => {
            trackInitiateCheckout();
            window.open('https://www.mellowreset.com/cart/43014126174274:1', '_blank');
          }} data-id="element-46">
              Empezar Ahora
            </Button>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-47">
              <div className="flex items-center gap-2" data-id="element-48">
                <Lock className="w-4 h-4" data-id="element-49" />
                <span data-id="element-50">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-51">
                <Shield className="w-4 h-4" data-id="element-52" />
                <span data-id="element-53">Garantía de 30 días</span>
              </div>
            </div>
          </div>
        </div>

        <p className="text-slate-500 text-sm" data-id="element-54">
          Si este libro no cambia tu perspectiva en 30 días, te devolvemos tu
          dinero. Sin preguntas.
        </p>
      </div>
    </section>;
}